import { createSlice, createEntityAdapter } from "@reduxjs/toolkit"

import type { RootState } from "redux/store"
import {
  handleFetchFulfilled,
  handleFetchPending,
  handleFetchRejected,
} from "redux/helpers/fetching"
import { createNps } from "redux/features/nps/npsThunk"

const npsAdapter = createEntityAdapter()
export const initialState = npsAdapter.getInitialState({
  fetchStatus: {
    isFetching: false,
    isSuccess: false,
    isFailed: false,
  },
})

export const npsSlice = createSlice({
  name: "nps",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(createNps.pending, (state) => handleFetchPending(state))
      .addCase(createNps.rejected, (state) => handleFetchRejected(state))
      .addCase(createNps.fulfilled, (state, { payload }) => {
        npsAdapter.setAll(state, payload)
        handleFetchFulfilled(state)
      })
  },
})

export const selectFetchStatus = (state: RootState) =>
  state.features.nps.fetchStatus

export default npsSlice.reducer
